import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { SERVICES, WHATSAPP_URL } from "./data";

export const Services = () => (
    <section id="services" data-testid="services-section" className="bg-[#FAF5EF] py-24">
        <div className="mx-auto max-w-6xl px-5">
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#D4AF37]">Our Services</p>
            <h2 className="mt-3 max-w-2xl font-serif text-4xl tracking-tight text-[#2C2A29] sm:text-5xl">
                Wedding makeup in Chennai, done to perfection
            </h2>
            <div className="mt-14 grid gap-6 md:grid-cols-3">
                {SERVICES.map(({ icon: Icon, name, desc }, i) => (
                    <motion.div
                        key={name}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.4, delay: (i % 3) * 0.08 }}
                        data-testid={`service-card-${i}`}
                        className="group rounded-sm border border-[#D4AF37]/20 bg-white p-8 transition-shadow duration-300 hover:shadow-[0_20px_40px_-20px_rgba(212,175,55,0.35)]"
                    >
                        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#E6B8B8]/30">
                            <Icon className="h-6 w-6 text-[#D4AF37]" />
                        </span>
                        <h3 className="mt-5 font-serif text-2xl font-medium text-[#2C2A29]">{name}</h3>
                        <p className="mt-2 text-sm leading-relaxed text-[#5A5652]">{desc}</p>
                        <a
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid={`service-whatsapp-link-${i}`}
                            className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-[#25D366] transition-transform duration-200 group-hover:translate-x-1"
                        >
                            <MessageCircle className="h-4 w-4" />
                            Book on WhatsApp
                        </a>
                    </motion.div>
                ))}
            </div>
        </div>
    </section>
);
